/**
 * Normalize run owner fields from Firestore (string uid or DocumentReference to users/{uid}).
 */
export function normalizeOwnerUidField(v) {
  if (v == null || v === '') return '';
  if (typeof v === 'string') {
    const s = v.trim();
    const usersIdx = s.lastIndexOf('/users/');
    if (usersIdx >= 0) {
      const tail = s.slice(usersIdx + '/users/'.length).split('/')[0];
      if (tail) return tail;
    }
    if (s.startsWith('users/')) {
      const tail = s.slice('users/'.length).split('/')[0];
      if (tail) return tail;
    }
    return s;
  }
  if (typeof v === 'object') {
    if (typeof v.path === 'string') {
      const parts = v.path.split('/').filter(Boolean);
      const i = parts.lastIndexOf('users');
      if (i >= 0 && parts[i + 1]) return parts[i + 1];
    }
    if (typeof v.id === 'string' && v.id) return v.id;
  }
  return String(v);
}

/** True if uid owns the run document (userId / ownerId string or users/{uid} ref). */
export function ownsRunFirestoreDoc(uid, data) {
  if (!uid || !data || typeof data !== 'object') return false;
  return (
    normalizeOwnerUidField(data.userId) === uid ||
    normalizeOwnerUidField(data.ownerId) === uid
  );
}

/** Client-side gate aligned with firestore.rules runs read (owner, shared, manager, public). */
export function canViewRunClient(user, data) {
  if (!data || typeof data !== 'object') return false;
  if (data.visibility === 'public' || data.visibility === true) return true;
  const uid = user?.uid;
  if (!uid) return false;
  if (normalizeOwnerUidField(data.userId) === uid || normalizeOwnerUidField(data.ownerId) === uid) {
    return true;
  }
  if (Array.isArray(data.sharedWith)) {
    for (const x of data.sharedWith) {
      if (x === uid || normalizeOwnerUidField(x) === uid) return true;
    }
  }
  if (Array.isArray(data.visibleToManagerUids) && data.visibleToManagerUids.some((x) => String(x) === uid)) {
    return true;
  }
  return false;
}
